<template>
    <div id="businessList" class="businessList">
        <div class="headerBar" @click.stop="mapSettings.fullHeight = !mapSettings.fullHeight">
            <div class="text">
                What’s Nearby
            </div>
            <div class="icons">
                <img :src="getStaticImage('icons/location/list.png')">
            </div>
        </div>
        <div class="descktopMediaBox ">
            <div class="title">
                What’s Nearby
            </div>
        </div>
        <div
            class="business"
            v-for="(b,index) in list"
            :class="{active: (b.business_id === mapSettings.selectedBusinessID),}"
            :key="index"
            @click="selectStore({lat: Number(b.lat), lng: Number(b.lon)}, b)"
            :id="('businessStore' + b.business_id)"
        >
            <div class="visiblEbox" :class="{index: b.business_id}">
                <div class="selectIcon mediaHideOnDesctop">
                
                </div>
                <div class="textBox">
                    <div class="address">
                        <div class="descktopMediaBox h4">{{b.business_name}}</div>
                        <div>{{b.address1}}</div>
                        <div>{{b.city}}, {{b.state}} {{b.zipcode}}</div>
                    </div>
                    <div class="distBox">
                        <div class="dist">
                            {{b.distance}} <span class="descktopMediaBox">miles</span>
                        </div>
                        <div class="pick">
                            <img :src="getStaticImage('icons/location/bascket.png')">
                            <span>Pickup</span>
                        </div>
                    </div>
                    <div class="descktopMediaBox btnlink zbg" @click="selectStore({lat: Number(b.lat), lng: Number(b.lon)}, b.business_id)" tabindex="0" @keypress.enter="$emit('choselocation')" style="cursor: pointer">
                        Pickup from here
                    </div>
                </div>
                
                <div class="moreInfo mediaHideOnDesctop" @click.stop="showMoreInfoBox(index,b.business_id)" :class="`bus${b.business_id}`">
                    <img :src="getStaticImage('icons/location/info.png')">
                </div>
            </div>
            <div :id="'hiddenInform' + b.business_id" class="hiddenInform pt-4" v-if="$route.query.location == index">
                <hr>
                <div class="location">
                    <div class="h1 mb-3">{{b.business_name}}</div>
                    <div class="address mb-3">
                        <div>{{b.address1}}</div>
                        <div>{{b.city}}, {{b.state}} {{b.zipcode}}</div>
                    </div>
                </div>
                <hr>
                <div class="workTime">
                    <div
                        v-for="(day,ind) in b.operation_hours"
                        class="d-flex justify-content-between mb-0"
                        :class="{'h4': ( ind == moment().format('ddd').toLowerCase() ) }"
                    >
                        <div>{{ days[ind] }}</div>
                        <div>{{day[0].operation_hours}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import moment from "moment";
    import $ from 'jquery';

    export default {
        name: "BusinessList",
        props: ['choselocation'],
        data() {
            return {
                curentDay: "mon",
                days: {
                    mon: "Monday",
                    tue: "Tuesday",
                    wed: "Wednesday",
                    thu: "Thursday",
                    fri: "Friday",
                    sat: "Saturday",
                    sun: "Sunday",
                }
            }
        },
        methods: {
            initList() {
                this.$store.dispatch("businesses/calcClosest");
            },
            selectStore(position, business) {
                let business_id = business.business_id;
                this.mapSettings.center = position;
                this.mapSettings.selectedBusinessID = business_id;
                if(parseInt(business.order_ability) === 0 || parseInt(business.takeout) === 0){
                    //this.$store.commit("shared/setAlert", "This location is currently not accepting online orders");
                    this.$modal.show("promt-modal", {
                        title: "Warning!", content: "This location is currently not accepting online orders?", success: () => {
                            this.scrollTo(`#businessStore${business_id}`);
                            this.$emit('choselocation');
                        }
                    })
                    return false
                }
                this.scrollTo(`#businessStore${business_id}`);
                this.$emit('choselocation');
            },
            moment: function () {
                return moment();
            },
            showMoreInfoBox(index, business_id) {
                if (this.$route.query.location != index) {
                    this.$router.push({name: 'Locations', query: {location: index}})
                    this.mapSettings.selectedBusinessID = business_id;
                    this.scrollTo(`#hiddenInform${business_id}`);
                    this.mapSettings.fullHeight = true;
                }else{
                    this.$router.push({name: 'Locations'});
                    this.mapSettings.fullHeight = false;
                }
            },
            scrollTo(selector) {
                this.$nextTick(() => {
                    if ($(selector).length){
                        $("#businessList").animate({
                            scrollTop: $('#businessList').scrollTop() + ($(selector).offset().top - 300)
                        }, 500);
                    }
                })
            }
        },
        computed: {
            ...mapState("businesses", ["list", "mapSettings"])
        },
        watch: {
            'mapSettings.position': function () {
                this.initList();
            }
        }

    }
</script>
